import { render, staticRenderFns } from "./InputMovil.vue?vue&type=template&id=b4cf547e&"
import script from "./InputMovil.vue?vue&type=script&lang=js&"
export * from "./InputMovil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports